/*
  readBlobAsText.js
*/

/**
 * reads a blob as text.
 */
export default function readBlobAsText(blob, encoding = 'UTF-8') {
  return new Promise((resolve, reject) => {

    const reader = new FileReader();
    reader.readAsText(blob, encoding);
    
    reader.onload = (event) => {
      resolve(event.target.result);
    };

    reader.onerror = (event) => {
      reject(event);
    };

  });
}
